import { VIDEO_CALLBACK_FETCHED_SUCCESS } from '../constants/actionTypes';

const initialState = {
  videoCallbacks: [],
  message: '',
  pager: {
    current: 1,
    pageSize: 15,
    total: 0,
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case VIDEO_CALLBACK_FETCHED_SUCCESS:
      return {
        ...state,
        videoCallbacks: action.payload.videoCallbacks,
        pager: action.payload.pager,
      };
    default:
      return state;
  }
};
